import './CustomPropertySelect.css';

type CustomPropertySelectProps = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  options: string[];
  placeholder: string;
};

export const CustomPropertySelect = ({
  id,
  value,
  onChange,
  options,
  placeholder,
}: CustomPropertySelectProps) => (
  <div className="container__input">
    <select
      id={id}
      className="custom-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">{placeholder}</option>
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  </div>
);
